module.exports = __webpack_public_path__ + "static/media/rentabilidad.915d7284.png";